import { createAction } from '@sde/widgets-core/src/redux/helpers/createAction';
import {
  GET_ORGANIZATIONS,
  GET_TAX_ID_NUMBERS,
  GET_PROVIDERS,
  GET_SAVED_PROVIDER,
  POST_SAVED_PROVIDER,
} from './constants';
import {
  getOrganizationsSaga,
  getTaxIdNumbersSaga,
  getProvidersSaga,
  getSavedProviderSaga,
  postSavedProviderSaga,
} from './sagas';

export const getOrganizations = (payload, onSuccess, onError) => {
  return createAction({
    type: GET_ORGANIZATIONS,
    payload,
    meta: { onSuccess, onError, async: getOrganizationsSaga },
  });
};

export const getTaxIdNumbers = (payload, onSuccess, onError) => {
  return createAction({
    type: GET_TAX_ID_NUMBERS,
    payload,
    meta: { onSuccess, onError, async: getTaxIdNumbersSaga },
  });
};

export const getProviders = (payload, onSuccess, onError) => {
  return createAction({
    type: GET_PROVIDERS,
    payload,
    meta: { onSuccess, onError, async: getProvidersSaga },
  });
};

export const getSavedProvider = (payload, onSuccess, onError) => {
  return createAction({
    type: GET_SAVED_PROVIDER,
    payload,
    meta: {
      onSuccess,
      onError,
      async: getSavedProviderSaga,
    },
  });
};

export const postSavedProvider = (payload, onSuccess, onError) => {
  return createAction({
    type: POST_SAVED_PROVIDER,
    cache: false,
    payload,
    meta: { onSuccess, onError, async: postSavedProviderSaga },
  });
};
